import React, { useState, useEffect } from "react";
import { Modal, Spin, message, Empty, Card, Image, Button } from "antd";
import {
  FileTextOutlined,
  EditOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import { FaUserPlus } from "react-icons/fa";
import drEasyApi from "../../../Api/Customapi";
import { getImg } from "../../../Api/getImg";
import dayjs from "dayjs";
import { formatDateTime } from "../../../utils/helpers";

const ReportViewModal = ({
  visible,
  onCancel,
  bookingId,
  userId,
  isMobile,
  sessionId,
  booking,
  onEditInvoice,
  onAssignSpecialist,
  showActions = true,
  reportEndpoint
}) => {
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [orderReport, setOrderReport] = useState(null);

  useEffect(() => {
    if (visible ) {
      fetchReports();
    }
  }, [visible, bookingId, sessionId,userId]);

  const fetchReports = async () => {
    setLoading(true);
    try {
      // Fetch medical report if userId exists
      // if (userId) {
      //   try {
      //     const medicalResponse = await drEasyApi.get("/api/Reports/GetUserReport", {
      //       params: { userID: userId },
      //     });
      //     setReportData(medicalResponse.data || null);
      //   } catch (error) {
      //     console.log("No medical report found");
      //     setReportData(null);
      //   }
      // }

      // Fetch order/financial report
      try {
      const orderResponse = await drEasyApi.get("/api/Reports/OrderReport",{params:{patientSessionId:sessionId,bookingId:bookingId}});
      setOrderReport(orderResponse.data || null);
      } catch (error) {
        console.log("No order report found");
        setOrderReport(null);
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
      message.error("Failed to fetch report data");
    } finally {
      setLoading(false);
    }
  };

  const hasAnyData =
    reportData?.body ||
    (reportData?.reportSections && reportData.reportSections.length > 0) ||
    orderReport;

  return (
    <Modal
      title={
        <div className="flex items-center">
          <div
            className={`${
              isMobile ? "w-6 h-6" : "w-8 h-8"
            } bg-gradient-to-r from-primary to-primary_hover rounded-full flex items-center justify-center ${
              isMobile ? "mr-2" : "mr-3"
            }`}
          >
            <FileTextOutlined
              className={`text-white ${isMobile ? "text-xs" : "text-sm"}`}
            />
          </div>
          <span className={isMobile ? "text-sm" : ""}>
            Patient Report{" "}
            {booking?.patientName ? `- ${booking.patientName}` : ""}
          </span>
        </div>
      }
      open={visible}
      onCancel={onCancel}
      width={isMobile ? "95vw" : 900}
      centered={isMobile}
      className="report-view-modal"
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Close
        </Button>,
      ]}
    >
      <Spin spinning={loading}>
        {hasAnyData ? (
          <div className={`space-y-4 ${isMobile ? "" : ""}`}>
            {/* Report Info Card */}
            <Card className="bg-blue-50 border border-blue-200">
              <div
                className={`flex items-center justify-between ${
                  isMobile ? "flex-col items-start gap-2" : ""
                }`}
              >
                <div>
                  <p
                    className={`text-blue-800 font-medium ${
                      isMobile ? "text-sm" : ""
                    }`}
                  >
                    Report Generated: {dayjs().format("MMMM D, YYYY h:mm A")}
                  </p>
                  {booking && (
                    <p
                      className={`text-blue-700 mt-1 ${
                        isMobile ? "text-xs" : "text-sm"
                      }`}
                    >
                      👤 Patient: {booking.patientName} | 📍 Clinic:{" "}
                      {booking.clinicName}
                    </p>
                  )}
                </div>
              </div>
            </Card>

            {/* Medical Report Body Section */}
            {/* {reportData?.body && (
              <div>
                <h3
                  className={`font-semibold text-gray-800 mb-3 flex items-center ${
                    isMobile ? "text-sm" : ""
                  }`}
                >
                  <FileTextOutlined className="mr-2 text-primary" />
                  Medical Report Details
                </h3>
                <Card
                  className={`border-l-4 border-l-primary ${
                    isMobile ? "p-3" : "p-4"
                  }`}
                  style={{ background: "#f9f9f9" }}
                >
                  <p
                    className={`text-gray-700 leading-relaxed whitespace-pre-wrap ${
                      isMobile ? "text-sm" : ""
                    }`}
                  >
                    {reportData.body}
                  </p>
                </Card>
              </div>
            )} */}

            {/* Medical Report Sections */}
            {/* {reportData?.reportSections &&
              reportData.reportSections.length > 0 && (
                <div>
                  <h3
                    className={`font-semibold text-gray-800 mb-3 flex items-center ${
                      isMobile ? "text-sm" : ""
                    }`}
                  >
                    <FileTextOutlined className="mr-2 text-primary" />
                    Medical Report Sections ({reportData.reportSections.length})
                  </h3>
                  <div className="space-y-3">
                    {reportData.reportSections.map((section, index) => (
                      <Card
                        key={index}
                        className="border-l-4 border-l-primary"
                        style={{ background: "#f9f9f9" }}
                      >
                        <div>
                          <div className="mb-2">
                            <h4
                              className={`font-semibold text-gray-800 text-primary ${
                                isMobile ? "text-sm" : "text-base"
                              }`}
                            >
                              {section.title || `Section ${index + 1}`}
                            </h4>
                            {section.createdAt && (
                              <p className="text-xs text-gray-500 mt-1">
                                {formatDateTime(section.createdAt)}
                              </p>
                            )}
                          </div>
                          <p
                            className={`text-gray-700 leading-relaxed whitespace-pre-wrap ${
                              isMobile ? "text-sm" : ""
                            }`}
                          >
                            {section.body || "No content available"}
                          </p>

                          {section.photoIds && section.photoIds.length > 0 && (
                            <div className="flex items-center gap-2 mt-3 flex-wrap">
                              {section.photoIds.map((photoId, imgIndex) => (
                                <Image
                                  key={imgIndex}
                                  src={getImg(photoId)}
                                  alt={`Section image ${imgIndex + 1}`}
                                  className="rounded-lg"
                                  style={{
                                    maxHeight: "90px",
                                    objectFit: "cover",
                                    width: "auto",
                                  }}
                                  fallback="https://res.cloudinary.com/dk2uh7sho/image/upload/v1750278754/default-img_tbc2pe.jpg"
                                />
                              ))}
                            </div>
                          )}
                        </div>
                      </Card>
                    ))}
                  </div>
                </div>
              )} */}

            {/* Medical Report Images/Photos */}
            {/* {reportData?.photoIds && reportData.photoIds.length > 0 && (
              <div>
                <h3
                  className={`font-semibold text-gray-800 mb-3 flex items-center ${
                    isMobile ? "text-sm" : ""
                  }`}
                >
                  📸 Medical Report Attachments ({reportData.photoIds.length})
                </h3>
                <div
                  className={`grid gap-4 ${
                    isMobile ? "grid-cols-2" : "grid-cols-3"
                  }`}
                >
                  {reportData.photoIds.map((photoId, index) => (
                    <Card key={index} className="overflow-hidden">
                      <Image
                        src={getImg(photoId)}
                        alt={`Report Photo ${index + 1}`}
                        className="rounded-lg"
                        style={{
                          maxHeight: "300px",
                          objectFit: "cover",
                          width: "100%",
                        }}
                        fallback="https://res.cloudinary.com/dk2uh7sho/image/upload/v1750278754/default-img_tbc2pe.jpg"
                      />
                      <p
                        className={`text-center text-gray-600 mt-2 ${
                          isMobile ? "text-xs" : "text-sm"
                        }`}
                      >
                        Photo {index + 1}
                      </p>
                    </Card>
                  ))}
                </div>
              </div>
            )} */}

            {/* Financial/Order Report Section */}
            {orderReport && (
              <div>
                <h3
                  className={`font-semibold text-gray-800 mb-3 flex items-center ${
                    isMobile ? "text-sm" : ""
                  }`}
                >
                  <DollarOutlined className="mr-2 text-primary" />
                  Report
                </h3>

                <Card className="border-l-4 border-l-primary bg-primary/5">
                  {/* Order Info */}
                  <div className="mb-4 pb-4 border-b border-gray-200">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-xs text-gray-600 mb-1">Order ID</p>
                        <p
                          className={`font-semibold text-gray-900 ${
                            isMobile ? "text-xs" : "text-sm"
                          }`}
                        >
                          {orderReport.id}
                        </p>
                      </div>
                      <div>
                        <p className="text-xs text-gray-600 mb-1">Created At</p>
                        <p
                          className={`font-semibold text-gray-900 ${
                            isMobile ? "text-xs" : "text-sm"
                          }`}
                        >
                          {formatDateTime(`${orderReport.createdAt}Z`)}
                        </p>
                      </div>
                    </div>

                    {orderReport.notes && (
                      <div className="mt-3">
                        <p className="text-xs text-gray-600 mb-1">
                          Order Notes
                        </p>
                        <p
                          className={`text-gray-800 bg-white p-3 rounded-lg ${
                            isMobile ? "text-sm" : ""
                          }`}
                        >
                          {orderReport.notes}
                        </p>
                      </div>
                    )}
                  </div>

                  {/* Services List */}
                  <div>
                    <p
                      className={`font-semibold text-gray-800 mb-3 ${
                        isMobile ? "text-sm" : ""
                      }`}
                    >
                      Services Ordered ({orderReport.services.length})
                    </p>
                    <div className="space-y-3">
                      {orderReport.services.map((service, index) => (
                        <div
                          key={index}
                          className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm"
                        >
                          <div className="flex justify-between items-start mb-2">
                            <div className="flex-1">
                              <h4
                                className={`font-semibold text-gray-900 ${
                                  isMobile ? "text-sm" : "text-base"
                                }`}
                              >
                                {service.serviceTitle}
                              </h4>
                              <p
                                className={`text-gray-600 mt-1 ${
                                  isMobile ? "text-xs" : "text-sm"
                                }`}
                              >
                                Quantity: {service.quantity} × EGP{" "}
                                {(service.price ?? 0).toFixed(2)}
                              </p>
                            </div>
                            <div className="text-right">
                              <p
                                className={`font-bold text-green-600 ${
                                  isMobile ? "text-base" : "text-lg"
                                }`}
                              >
                                EGP{" "}
                                {(
                                  service.quantity * (service.price ?? 0)
                                ).toFixed(2)}
                              </p>
                            </div>
                          </div>

                          {service.note && (
                            <div className="mt-2 pt-2 border-t border-gray-200">
                              <p className="text-xs text-gray-600 mb-1">
                                Service Note:
                              </p>
                              <p
                                className={`text-gray-700 italic ${
                                  isMobile ? "text-xs" : "text-sm"
                                }`}
                              >
                                {service.note}
                              </p>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>

                    {/* Total */}
                    <div className="mt-4 pt-4 border-t-2 border-primary -600   p-4 rounded-lg">
                      <div className="flex justify-between items-center">
                        <span
                          className={`font-bold text-gray-800 ${
                            isMobile ? "text-base" : "text-lg"
                          }`}
                        >
                          Total Amount:
                        </span>
                        <span
                          className={`font-bold text-green-600 ${
                            isMobile ? "text-xl" : "text-2xl"
                          }`}
                        >
                          EGP{" "}
                          {orderReport.services
                            .reduce(
                              (total, service) =>
                                total + service.quantity * (service.price ?? 0),
                              0,
                            )
                            .toFixed(2)}
                        </span>
                      </div>
                    </div>
                  </div>
                </Card>
              </div>
            )}

            {/* Action Buttons Section */}
            {showActions && (
              <Card className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 mt-6">
                <h3
                  className={`font-semibold text-gray-800 mb-4 ${
                    isMobile ? "text-sm" : ""
                  }`}
                >
                  Quick Actions
                </h3>
                <div className={`flex gap-3 ${isMobile ? "flex-col" : ""}`}>
                  <Button
                    type="primary"
                    icon={<EditOutlined />}
                    onClick={onEditInvoice}
                    size={isMobile ? "middle" : "large"}
                    className="bg-primary border-none hover:bg-primary_hover flex-1"
                  >
                    Edit Invoice
                  </Button>
                  <Button
                    type="primary"
                    icon={<FaUserPlus className="inline mb-[2px]" />}
                    onClick={onAssignSpecialist}
                    size={isMobile ? "middle" : "large"}
                    className="bg-secondary border-none hover:bg-green-600 flex-1"
                  >
                    Assign to Specialist
                  </Button>
                </div>
              </Card>
            )}
          </div>
        ) : (
          <Empty
            description="No report data available for this booking"
            style={{ marginTop: "40px", marginBottom: "40px" }}
          />
        )}
      </Spin>
    </Modal>
  );
};

export default ReportViewModal;
